// Mai Shayi — horizontal product rail arrows.
// Scrolls by one card pitch; arrows disable at the ends and hide when the
// track has nothing to scroll.
(() => {
  const wire = (rail) => {
    if (rail.dataset.msRailReady) return;
    rail.dataset.msRailReady = '1';

    const track = rail.querySelector('[data-ms-rail-track]');
    const prev = rail.querySelector('[data-ms-rail-prev]');
    const next = rail.querySelector('[data-ms-rail-next]');
    if (!track || !prev || !next) return;

    const step = () => {
      const card = track.firstElementChild;
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      const idle = max < 2;
      prev.hidden = next.hidden = idle;
      if (idle) return;
      prev.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft > max - 2;
      prev.style.opacity = prev.disabled ? '0.35' : '';
      next.style.opacity = next.disabled ? '0.35' : '';
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    new ResizeObserver(sync).observe(track);
    sync();
  };

  const scan = () => document.querySelectorAll('[data-ms-rail]').forEach(wire);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Shopify theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', scan);
})();
